export default __webpack_public_path__ + "static/media/lab-data-logo.69f842f7.svg";